// Коды бизнес-ошибок + единый формат ответа об ошибке (см. backend.md §5).
// Фронт реагирует на `code`, никогда на `message` — message только для логов/дебага.
import { z } from 'zod'

// Коды, перечисленные в backend.md §5 как нужные сразу, плюс общий минимум
// (валидация, не найдено, доступ запрещён, троттлинг, непредвиденная ошибка сервера).
export const ERROR_CODES = [
  'INVITE_EXPIRED',
  'INVITE_ALREADY_USED',
  'INVITE_REVOKED',
  'LINK_LIMIT_REACHED',
  'LINK_ALREADY_EXISTS',
  'LINK_SELF_FORBIDDEN',
  // Часовой кулдаун на одного человека снят (решение основателя) — сервер этот код больше
  // не выдаёт. Значение оставлено в перечислении намеренно: выкаченные клиенты валидируют
  // тело ошибки этой схемой и не должны падать на незнакомом коде. Удалять — только когда
  // старые версии мини-аппа перестанут ходить в API.
  'RAY_COOLDOWN',
  'RAY_DAILY_LIMIT_REACHED',
  'AGE_RESTRICTED',
  'BIRTH_DATE_IN_FUTURE',
  'NATAL_NO_BIRTH_TIME',
  'UNAUTHORIZED',
  'TOKEN_EXPIRED',
  'VALIDATION_ERROR',
  'NOT_FOUND',
  'FORBIDDEN',
  'RATE_LIMITED',
  'INTERNAL_ERROR',
] as const
export const errorCodeSchema = z.enum(ERROR_CODES)
export type ErrorCode = z.infer<typeof errorCodeSchema>

export const errorBodySchema = z.object({
  code: errorCodeSchema,
  message: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
})
export type ErrorBody = z.infer<typeof errorBodySchema>

// Единый формат ответа-ошибки: { error: { code, message, details? } }
export const errorResponseSchema = z.object({
  error: errorBodySchema,
})
export type ErrorResponse = z.infer<typeof errorResponseSchema>
